const _UTILS = {
  async AddItemsToCart(items_to_add) {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  },
  RefreshCart() {
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
  }
}

document.addEventListener('quick-addtocart', async(e) => {
  // console.log(e);
  if (!e.detail.product) return;

  let variant = e.detail.product.variants.find(v => v.available);
  let items_to_add = [{
      quantity: 1,
      id: variant.id
    }];

  await _UTILS.AddItemsToCart(items_to_add);
  _UTILS.RefreshCart();
});

document.addEventListener('alpine:init', () => {
});